export default "__VITE_ASSET__hjjUaw_n__"